$(document).ready(() => {
	$('.toggleControl').on('click touch', function (e) {
		e.preventDefault()
		$(this).toggleClass('closed')
		$(this).parent().siblings('.filtersGroupPanel').slideToggle()
	})
})
